/**
 * Utility function to sort items by updated_at date in descending order (most recent first)
 * @param items Array of items that have an optional updated_at field
 * @returns Sorted array with most recently updated items first
 */
export function sortByUpdatedAt<T extends { updated_at?: string | Date }>(
  items: T[],
): T[] {
  const toTimestamp = (value?: string | Date): number => {
    if (!value) return Number.NEGATIVE_INFINITY;
    const date = value instanceof Date ? value : new Date(value);
    const time = date.getTime();
    return isNaN(time) ? Number.NEGATIVE_INFINITY : time;
  };

  return items.sort(
    (a, b) => toTimestamp(b.updated_at) - toTimestamp(a.updated_at),
  );
}
